export default __webpack_public_path__ + "static/media/sleep.e7500add.jpeg";